import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Admin from '@/components/Admin'
import ReturnList from '@/components/admin/ReturnList'
import OrderList from '@/components/admin/OrderList'
import Order from '@/components/admin/Order'
import OrderForCentral from '@/components/admin/OrderForCentral'
import CollectList from '@/components/admin/CollectList'
import ShopList from '@/components/admin/ShopList'
import ShopSettings from '@/components/admin/ShopSettings'
import VueMeta from 'vue-meta'

Vue.use(Router)
Vue.use(VueMeta)
export const settings = {
  getApiRoute (routeName, params) {
    let paramsObj = typeof params === 'undefined' ? {} : params
    let serverURI = ''
    if (process.env.user && process.env.user === 'dami') {
      serverURI = '//bck.patrizia_omniway.v1'
    } else if (process.env.user && process.env.user === 'dami-remote') {
      serverURI = '//bck.patrizia_omniway.dev.waynet.pl'
    } else if (process.env.NODE_ENV === 'development') {
      serverURI = '//localhost:3000'
    } else {
      serverURI = process.env.API_URL
    }
    if (typeof this.apiRoutes[routeName] === 'string') {
      let route = this.apiRoutes[routeName]
      for (let key in paramsObj) {
        let reg = new RegExp('{' + key + '}', 'i')
        route = route.replace(reg, paramsObj[key])
      }
      return serverURI + route
    } else {
      return serverURI + '/' + routeName
    }
  },
  apiRoutes: {
    /* -p suffix in route name mean tha this route support requestParams convention */
    'settings': '/settings',
    'login': '/login',
    'login-resp': '/login-resp',
    'logout': '/logout',
    'return-list': '/return',
    'return': '/return/{reference}',
    'return-stores': '/return-stores',
    /* central */
    'confirm-return': '/return/{reference}/confirm',
    'return-p': '/return-p',
    'order': '/order/{reference}',
    'order-return': '/order/{reference}/return',
    'order-return-pdf': '/pdf/order/return/{code}',
    'order-collect-pdf': '/pdf/order/collect/{reference}',
    'order-p': '/order-p',
    'shop': '/shop',
    'shop-settings': '/shop/{code}',
    'collect': '/collect/{reference}',
    'collect-stores': '/collect-stores',
    'collect-list': '/collect',
    'collect-p': '/collect-p',
    // helper services
    'order-states': '/order-p-states',
    'collect-states': '/collect-p-states',
    'return-states': '/return-p-states',
    'customer': '/customer/{id_customer}'
    // dispatches: {
    //   url: '/dispatches'
    // }
  },
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      children: [
        {
          path: 'order-list/:reference',
          name: 'Order',
          component: Order
        },
        {
          path: 'order-list',
          name: 'OrderList',
          component: OrderList,
          meta: {
            keepalive: true
          }
        },
        {
          path: 'return-list/:reference',
          name: 'Return',
          component: OrderForCentral
        },
        {
          path: 'return-list',
          name: 'ReturnList',
          component: ReturnList
        },
        {
          path: 'collect-list/:reference',
          name: 'Collect',
          component: OrderForCentral
        },
        {
          path: 'collect-list',
          name: 'CollectList',
          component: CollectList
        },
        {
          path: 'shop-list/:code',
          name: 'ShopSettings',
          component: ShopSettings
        },
        {
          path: 'shop-list',
          name: 'ShopList',
          component: ShopList
        }
      ]
    },
    {
      path: '/*',
      redirect: to => {
        return '/'
      }
    }

  ]
}
export default new Router(settings)



// WEBPACK FOOTER //
// ./src/router/index.js